const LOCAL_STORAGE_KEY = 'myTalquin:state';

/**
 * Deserializes the app state from local storage.
 */
export function getSession(): null | any {
  try {
    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (serializedState === null) {
      return null;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return null;
  }
}

/**
 * Serializes the app state to local storage.
 *
 * @param state The app state.
 */
export function saveSession(state: any) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(LOCAL_STORAGE_KEY, serializedState);
  } catch (err) {
  }
}
